import first from 'lodash/first.js';

import Model from '@/models/Model.js';

export default class LocationContact extends Model {
    static entity = 'location_contacts';

    static modelName = 'LocationContact';

    static primaryKey = ['location_id', 'contact_id'];

    static fields() {
        return {
            location_id: this.attr(null),
            contact_id: this.attr(null),

            ...super.fields(),

            location: this.belongsTo('locations', 'location_id'),
            contacts: this.belongsTo('contacts', 'contact_id'),
        };
    }

    static sync(location, contactIds) {
        const removableContacts = location.contacts.filter(contact => !contactIds.includes(contact.id));

        removableContacts.forEach(contact => LocationContact.delete([location.id, contact.id]));

        const addableContacts = contactIds.filter(
            contactId => !location.contacts.map(existingContact => existingContact.id).includes(contactId)
        );

        addableContacts.forEach(contactId =>
            LocationContact.insert({
                data: {
                    location_id: location.id,
                    contact_id: contactId,
                },
            })
        );

        if (!contactIds.includes(location.primary_contact_id)) {
            location.$update({ primary_contact_id: first(contactIds) });
        }
    }
}
